/**
 * Retrieves a list of job categories and values for a given user.
 * @async
 * @function
 * @param {Object} userData - The user data object.
 * @returns {Promise<Object>} - A promise that resolves to an object containing the job categories and values.
 */
import { captureException } from '@playbookux/playbook-web-core';
import _ from 'lodash';
import api from '../services/api';
import { getCatSubCat } from './get-cat-subcat';

const getJobsList = async (userData) => {
  try {
    const response = await api.listJobCategories();
    const responseObj = {
      values: {},
      jobsSelected: [],
    };

    const values = getCatSubCat(response);

    if (values.length > 0) {
      responseObj.values = values;
    } else {
      responseObj.values = {};
    }

    if (_.isEmpty(userData)) return responseObj;

    const { user = {} } = userData || {};
    const { profile = {} } = user;
    const { jobCategories = {} } = profile;

    if (!_.isEmpty(jobCategories)) {
      responseObj.jobsSelected = jobCategories;
    } else {
      responseObj.jobsSelected = [];
    }

    return responseObj;
  } catch (error) {
    captureException('GET_JOBS_LIST_SIGN_UP_SURVEY_FAILED', error);
    return { values: {}, jobsSelected: [], error };
  }
};

export default getJobsList;
